import { Protocol } from '../Protocol';

export class ExptTestInDistrictProtocol {
  public static readonly GET_EXPT_TESTINDISTRICT_BY_AREA: string = `${Protocol.YATUNG_API_ROOT}/expt/area/status`;
  public static readonly GET_EXPT_TESTINDISTRICT_BY_FACTORY: string = `${Protocol.YATUNG_API_ROOT}/expt/factory/status`;
  public static readonly GET_PAGINATION_REQ_TESTINDISTRICT_FACTORY: string = `${Protocol.YATUNG_API_ROOT}/req/factory`;
}
